import { insertIf } from '../../../../../../../../../../../helpers/common'

import {
  assetColStyles,
  assetTypeColStyles,
  getCategoryColStyles,
  getRegionColStyles,
  locationColStyles,
  rateColStyles,
  reachColStyles
} from '../../../../../../ProductsTable/const/tableColumnsSize'

export const tableColumnsSize = {
  checkbox: 40,
  thumbnail: 65,
  periodsValidation: 54 // support 2 tooltip icons
}

export const getAddBulkProductsColumnsSchema = (classes, hasReachData = true, hideUnavailable) => [
  {
    header: 'Select all',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: { minWidth: tableColumnsSize.checkbox, maxWidth: tableColumnsSize.checkbox }
  },
  {
    header: 'Thumbnail',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: { minWidth: tableColumnsSize.thumbnail, maxWidth: tableColumnsSize.thumbnail }
  },
  {
    header: 'Region',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: getRegionColStyles(hasReachData)
  },
  {
    header: 'Location',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: locationColStyles
  },
  {
    header: 'Category',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: getCategoryColStyles(hasReachData)
  },
  {
    header: 'Asset Type',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: assetTypeColStyles
  },
  {
    header: 'Asset',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: assetColStyles
  },
  ...insertIf(!hideUnavailable, {
    header: 'Periods Validation',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: { minWidth: tableColumnsSize.periodsValidation, maxWidth: tableColumnsSize.periodsValidation }
  }),
  ...insertIf(hasReachData, {
    header: 'Reach',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: reachColStyles
  }),
  {
    header: 'Rate',
    headClassName: classes.quotationBuilderCol,
    className: classes.quotationBuilderCol,
    style: { ...rateColStyles, paddingRight: 20 }
  }
]
